import {useEffect} from 'react'
import {css} from '@emotion/react'
import {MarkdownViewer} from '@/components/Markdown'
import {eventBus} from '@/script/eventBus.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import runAsync from '@/script/runAsync.mjs'
import http from '@/biz/http.mjs'
import BaseMap from '../../BaseMap.jsx'
import ToolBar from './ToolBar.jsx'
import useReadMap from './useReadMap.mjs'

const cssSnapshotMarkdown = css({
    padding: 20,
    overflow: 'auto',
})

const components = {ToolBar}

const SnapshotMarkdown = ({data, ...props}) => {
    useEffect(
        () => {
            const {
                crtName: rlsName,
                crtTime: rlsTime,
                dataMap,
                dataName: mapName,
                dataType,
                dataVer: mapRev,
                patternRev,
                pkid: snapshotId,
                prjNo,
                prjPatternId,
                stsCode: mapStsCode,
                stsName: mapStsName,
                sVer,
            } = data

            const {data: {dpSn}} = JSON.parse(dataMap)
            console.log(JSON.parse(dataMap))

            const d = {
                dpSn,
                mapName,
                mapRev,
                mapStsCode,
                mapStsName,
                mapTypeCode: `_${dataType}_MAP`,
                patternRev,
                prjNo,
                prjPatternId,
                rlsName,
                rlsTime,
                snapshotId,
                sVer,
            }

            eventBus.publish('map_load', {data: d})
        },

        []
    )

    return (
        <div
            css={cssSnapshotMarkdown}
            {...props}
        >
            <MarkdownViewer>
                {data.dpContent}
            </MarkdownViewer>
        </div>
    )
}

const SnapshotMap = ({id, ...props}) => {
    const readMap = useReadMap(id)

    return (
        <BaseMap
            components={components}
            readMap={readMap}
            {...props}
        />
    )
}

export default function SnapshotMapWrapper({id, ...props}) {
    const {data} = useSwrNoCache(
        () => runAsync(
            () => http.get(`/basmapvers/${id}`),
            {action: '读取快照'}
        )
    )

    if (! data) {
        return null
    }

    if ('MD' === data.dpContentType) {
        return (
            <SnapshotMarkdown
                data={data}
                {...props}
            />
        )
    }
    else {
        return (
            <SnapshotMap
                id={id}
                {...props}
            />
        )
    }
}
